import { useContextState } from '../../../../../hooks/theme'

export const useStyles = () => {
  const { colors } = useContextState()

  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      overflow: 'hidden',
      gap: '14px',
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingTop: '8px',
      gap: '16px',
    },
    headerText: {
      display: 'flex',
      flexDirection: 'column',
    },
    headerActions: {
      display: 'flex',
      alignItems: 'center',
    },
    title: {
      fontSize: '16px',
      fontWeight: '600',
      color: colors.color13,
    },
    subtitle: {
      fontSize: '14px',
      color: colors.color10,
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
    },
    footer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    backButton: {
      color: colors.color4,
      textTransform: 'none',
      fontWeight: '500',
    },
    saveButton: {
      padding: '6px 17px',
      borderRadius: '5px',
      fontWeight: '500',
      textTransform: 'none',
    },
    modalConfirmation: {
      width: '400px',
      borderRadius: '12px',
    },
  }
}
